import { SingleNumberPickerComponent } from './pickers/single-number-picker.component';
import { DisplaySelectedLineComponent } from './pickers/display-selected-line';
import { NumberRangePickerComponent } from './pickers/number-range-picker.component';
import { LottoLineFormFieldComponent } from './lotto-line/form-field/lotto-line-form-field.component';
import { LottoLineTableCellComponent } from './lotto-line/table-cell/lotto-line-table-cell.component';
import { DrawOptionSortPipe } from './lotto-line/form-field/drawoption-sort.pipe';
import { ConditionFormFieldComponent } from './condition/form-field/condition-form-field.component';
import { ConditionTableCellComponent } from './condition/table-cell/condition-table-cell.component';
import { OfferFormFieldComponent } from './offer/form-field/offer-form-field.component';
import { OfferTableCellComponent } from './offer/table-cell/offer-table-cell.component';
import { OpenInPlayerFormFieldComponent } from './open-in-player/form-field/open-in-player-form-field.component';
import { RuleFormFieldComponent } from './rule/form-field/rule-form-field.component';

export const COMPONENTS: any[] = [
  SingleNumberPickerComponent,
  DisplaySelectedLineComponent,
  NumberRangePickerComponent,
  LottoLineFormFieldComponent,
  LottoLineTableCellComponent,
  ConditionFormFieldComponent,
  RuleFormFieldComponent,
  ConditionTableCellComponent,
  OfferFormFieldComponent,
  OfferTableCellComponent,
  OpenInPlayerFormFieldComponent,
];

export const PIPES: any[] = [DrawOptionSortPipe];

export const PAGES: any[] = [];

export const SERVICES: any[] = [];

export const DIRECTIVES: any[] = [];

export const MODULE_EXPORTS: any[] = [LottoLineFormFieldComponent, LottoLineTableCellComponent, DrawOptionSortPipe];

export {
  LottoLineFormFieldComponent,
  LottoLineTableCellComponent,
  DrawOptionSortPipe,
  ConditionFormFieldComponent,
  ConditionTableCellComponent,
  RuleFormFieldComponent,
  OfferFormFieldComponent,
  OfferTableCellComponent,
};
